exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dark-bg{\n\tbackground-color: #323643;\n}\n\n/*remove ng-host*/\n:host {\n  border:none !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/auth/sign-in/sign-in.component.css
// module id = ../../../../../src/app/auth/sign-in/sign-in.component.css
// module chunks = main